<section class="flex min-h-[60vh] items-center justify-center px-4">
  <div
    class="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm"
  >
    @if (loading) {
      <h1 class="text-2xl font-semibold text-slate-900">Verifying email...</h1>
      <p class="mt-3 text-slate-600">Please wait a moment.</p>
    }

    @if (!loading && success) {
      <h1 class="text-2xl font-semibold text-slate-900">Email verified</h1>
      <p class="mt-3 text-slate-600">Your email address has been confirmed. You can now log in.</p>
      <p class="mt-4 text-sm text-slate-500">Redirecting to login...</p>
    }

    @if (!loading && errorMessage) {
      <h1 class="text-2xl font-semibold text-slate-900">Verification failed</h1>
      <p class="mt-3 text-slate-600">{{ errorMessage }}</p>
      <a
        routerLink="/register"
        class="mt-6 inline-block rounded-lg bg-secondary px-4 py-2 font-semibold text-white"
      >
        Register again
      </a>
    }
  </div>
</section>
